"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactTimedResponse = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const streem_error_1 = require("../../streem_error");
const logger_1 = require("../logger");
const filter_null_1 = require("./filter_null");
function artifactTimedResponse(latestRequestId, latestResponses, opts) {
    return __awaiter(this, void 0, void 0, function* () {
        const { timeout = 30000 } = opts !== null && opts !== void 0 ? opts : {};
        if (timeout < 0) {
            throw new streem_error_1.StreemError('Timeout must be greater than 0ms');
        }
        // After timeout, return unfulfilled request
        const timedFailure = (0, rxjs_1.timer)(timeout).pipe((0, operators_1.switchMap)(() => {
            logger_1.logger.error(`Artifact request ${latestRequestId} has timed out`);
            return (0, rxjs_1.throwError)('Request timed out');
        }));
        // Attempt to find a geolocation or streemshot response that matches latestRequestId
        const matchingResponse = latestResponses.pipe((0, operators_1.map)((responses) => responses.find(res => res.inResponseToWallItemId === latestRequestId)), (0, filter_null_1.filterNull)(), (0, operators_1.tap)(() => logger_1.logger.info(`Artifact request ${latestRequestId} has been fulfilled`)));
        // Possible improvement: firstValueFrom when moving to rxjs 7
        return new Promise((resolve, reject) => {
            let value;
            (0, rxjs_1.race)(timedFailure, matchingResponse)
                .pipe((0, operators_1.take)(1))
                .subscribe((x) => (value = x), err => reject(err), () => resolve(value));
        });
    });
}
exports.artifactTimedResponse = artifactTimedResponse;
//# sourceMappingURL=artifact_timed_response.js.map